// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-60ccbafa]{background:#fff;padding-bottom:37px}.container .page_banner[data-v-60ccbafa]{width:100%;height:365px;background:url(/images/about/bg.png) no-repeat;background-size:100% 100%;padding-top:59px;padding-left:19px}.container .page_banner .page_title[data-v-60ccbafa]{font-size:30px;color:#131415;font-weight:700}.container .inner[data-v-60ccbafa]{margin-top:-220px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
